import { render } from "./Addata.vue?vue&type=template&id=f268edac&scoped=true&ts=true"
import script from "./Addata.vue?vue&type=script&lang=ts"
export * from "./Addata.vue?vue&type=script&lang=ts"

import "./Addata.vue?vue&type=style&index=0&id=f268edac&scoped=true&lang=css"

import exportComponent from "/Users/zhongyue/Desktop/work/hu-shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f268edac"]])

export default __exports__